import { TabNav as RadixTabNav } from '@radix-ui/themes'
import type { ComponentPropsWithoutRef } from 'react'
import { forwardRef } from 'react'

type TabNavSize = '1' | '2'
type TabNavJustify = 'start' | 'center' | 'end'
type TabNavWrap = 'nowrap' | 'wrap' | 'wrap-reverse'

type TabNavRootProps = ComponentPropsWithoutRef<typeof RadixTabNav.Root> & {
  size?: TabNavSize
  justify?: TabNavJustify
  wrap?: TabNavWrap
}

type TabNavLinkProps = ComponentPropsWithoutRef<typeof RadixTabNav.Link> & {
  active?: boolean
}

const TabNavRoot = forwardRef<HTMLDivElement, TabNavRootProps>(
  ({ size = '2', justify = 'start', wrap = 'nowrap', ...props }, ref) => {
    return (
      <RadixTabNav.Root
        justify={justify}
        ref={ref}
        size={size}
        wrap={wrap}
        {...props}
      />
    )
  }
)

TabNavRoot.displayName = 'TabNav.Root'

const TabNavLink = forwardRef<HTMLAnchorElement, TabNavLinkProps>(
  ({ active = false, ...props }, ref) => {
    return <RadixTabNav.Link active={active} ref={ref} {...props} />
  }
)

TabNavLink.displayName = 'TabNav.Link'

export const TabNav = {
  Root: TabNavRoot,
  Link: TabNavLink
}
